import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";

const Section6 = () => {
  const { t } = useTranslation();

  return (
    <motion.div
                initial="hidden"
                    whileInView="visible"
                    exit="exit"
                    variants={containerVariants}
    
    
    
    className='grid grid-cols-10 mt-28'>
      <div className=' w-full  overflow-hidden col-start-2 col-span-8 md:col-start-3 md:col-span-6   text-customGray '>
        <div className='md:w-[60%]'>
          <motion.h2 variants={itemVariants} className='text-65 font-semibold mb-5'>{t("socialResponsibility.speakForChange.title")}</motion.h2>
          <motion.p variants={itemVariants} className='mb-5'>{t("socialResponsibility.speakForChange.subtitle")}</motion.p>

          <motion.p variants={itemVariants} className='mb-10'>{t("socialResponsibility.speakForChange.text1")}
          </motion.p>

          <motion.p variants={itemVariants} className='whitespace-pre-line'>{t("socialResponsibility.speakForChange.text2")}</motion.p>

        </div>
      </div>

    </motion.div>
  )
}

export default Section6
